import redeemStatus from '@/constants/redeemStatus.js'

export function validateActivityAccess (data) {
  const result = {
    toNotFound: false,
    toProgramDetail: false,
    toKelasku: false
  }
  const {
    status,
    enrolled,
    activity_id,
    is_external,
    stage,
    is_admin,
    is_joined,
    has_user_group,
    is_asesor
  } = data
  if (status === 400 || status === 114 || status === 122) {
    result.toNotFound = true
    return result
  }
  if (
    !enrolled ||
    (!is_joined && has_user_group) ||
    is_external ||
    (stage.toLowerCase() === 'registration' && !is_admin && !is_asesor)
  ) {
    result.toProgramDetail = true
    return result
  }
  if (activity_id === 0) {
    result.toKelasku = true
    return result
  }
  return result
}

export function validateRedemptionProgram ({ purchase_type, has_redeem_program, redemption_program }) {
  const isPaidUsingPrakerja = purchase_type.toLowerCase() === 'prakerja'
  if (isPaidUsingPrakerja && redemption_program && (!has_redeem_program || has_redeem_program > redeemStatus.REDEEM_SUCCESS)) {
    return false
  }
  return true
}
